export function isOdd(code: string): boolean {
    return (Number(code) % 2) ? true : false;
}